//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import ItemsSearchField from '../../components/Field/ItemsSearchField.vue'
import { createFieldConfig, Store } from '../../components/QSelectUtils.js'

export default {
  name: 'RequestRemontPositionField',
  components: {
    ItemsSearchField
  },
  props: {
    request: {
      type: Object,
      default () {
        return {}
      }
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      toolValueSelected: null,
      toolFieldConfig: createFieldConfig(new Store({
        fullReadable: false,
        searchable: true,
        searchValueMinLength: 1,
        cached: true,
        proxy: {
          urlBase: '/service/obj/search',
          get urlParams () {
            const params = []
            if (this.searchValue) {
              params.push({ param: 'name', type: 'string', action: 'contains', value: this.searchValue, caseSensitive: false })
            }

            return {
              type: 'tool',
              sort: 'name',
              // add: ['unit', 'article'].join(',')
              params: JSON.stringify(params)
            }
          },
          searchCustom: true
        }
      }))
    }
  },
  computed: {
    toolValue: {
      get: function () {
        if (this.toolValueSelected) {
          return this.toolValueSelected
        } else if (this.request) {
          const id = this.request.remontPositionId || null
          const name = this.request.remontPositionName || id || null
          if (id || name) {
            return { id, name }
          }
        }
        return null
      },
      set: function (value) {
        this.toolValueSelected = value
        this.request.remontPositionId = value && value.id || null
        this.request.remontPositionName = value && value.name || null
      }
    },
    required: function () {
      return this.request._configuration.isFieldRequired('remontPositionName')
    }
  },
  methods: {
    onCreateNewValue (val, done) {
      done({
        id: null,
        name: val
      })
    },
    onInputValueStarted (updateInputValue) {
      if (this.toolValue && this.toolValue.id == null && this.toolValue.name) {
        updateInputValue(this.toolValue.name)
      }
    }
  }
}

